import { commitMutation, graphql } from 'react-relay';
import environment from '../data/environment';

const mutation = graphql`
  mutation PopulateReportMutation(
    $input: PopulateReportInput!
  ) {
    populateReport(input: $input) {
      report {
        id
        mongoId
        name
        layout {
          i
          x
          y
          w
          h
        }
        widgets {
          id
          mongoId
          name
          type
          config {
            filterComments
            sliceByQuestion
            aggregateQuestions
            subtitle
            ignoreDateFilter
            showLastXMonths
            hideHeader
            hideCommentTime
            staticYAxisScale
            commentExtraColumns {
              title
              questionId
            }
            question {
              id
              firstAnswerTime
            }
          }
        }
      }
    }
  }
`;

function commit({ reportId, surveyId }, callback) {
  commitMutation(
    environment,
    {
      mutation,
      variables: {
        input: {
          reportId,
          surveyId,
        },
      },
      onCompleted: (res) => {
        callback(null);
      },
      onError: (err) => {
        callback(err);
      },
    },
  );
}

export default { commit };



// WEBPACK FOOTER //
// ./src/mutations/PopulateReportMutation.js